import { render, staticRenderFns } from "./MerchantTable.vue?vue&type=template&id=3c459d0a&"
import script from "./MerchantTable.vue?vue&type=script&lang=js&"
export * from "./MerchantTable.vue?vue&type=script&lang=js&"
import style0 from "./MerchantTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantTable.vue"
export default component.exports